<template>
  <v-container id="table-guias" class="pa-0">

    <v-row class="px-3 py-5">
      <v-btn outlined small  height="32px" color="primary" class="px-1 mr-3" depressed :disabled="listaTemporaria.length<1" @click="selecionaTodos({value: !selecionarTodos[tipo_consulta]})" >{{!selecionarTodos[tipo_consulta] ?'Selecionar todos' :'Desmarcar todos'}}</v-btn>
      <v-btn outlined small  height="32px" color="primary" class="px-1 mr-3" depressed :disabled="(dataMassToSave[tipo_consulta].filter(el => el.selected).length<2 && (!selecionarTodos[tipo_consulta] && dataMassToSave[tipo_consulta].filter(el => el.selected).length<2))" @click="edicaoEmMassa(selecionarTodos[tipo_consulta])">Edição em massa</v-btn>
      <v-btn v-show="habilitaAnexoMassa"
      outlined small  height="32px" color="primary" class="px-1 mr-3" depressed :disabled="(dataMassToSave[tipo_consulta].filter(el => el.selected).length<2 && (!selecionarTodos[tipo_consulta] && dataMassToSave[tipo_consulta].filter(el => el.selected).length<2))" @click="anexarEmMassa(selecionarTodos[tipo_consulta])">Anexar em massa</v-btn>
      <v-btn outlined small  height="32px" color="primary" class="px-1 mr-3" depressed :disabled="(dataMassToSave[tipo_consulta].filter(el => el.selected).length<2 && (!selecionarTodos[tipo_consulta] && dataMassToSave[tipo_consulta].filter(el => el.selected).length<2))" @click="desfazerEdicaoRecursoConfirm(dataMassToSave[tipo_consulta], selecionarTodos[tipo_consulta], true)">Apagar análises</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-show="habilitaAnexoMassa" outlined small  height="32px" color="primary" class="px-1 mr-3" @click="openGestao()">Listar anexos</v-btn>
      <v-btn outlined small  height="32px" color="primary" class="px-1 mr-3" @click="downloadFile()">Exportar resultado</v-btn>
      <v-btn small  height="32px" color="primary" class="px-1 ml-1" depressed :disabled="dataToSave[tipo_consulta].length < 1" @click="confirmSaveEdicoesIndividuais()">Salvar alterações</v-btn>
    </v-row>
    <p v-if="dataMassToSave[tipo_consulta].filter(el => el.selected).length>0 || selecionarTodos[tipo_consulta]" class="mb-0"> 
      Seleção: <b>{{selecionarTodos[tipo_consulta] ? pagination.total-dataMassToSave[tipo_consulta].length :dataMassToSave[tipo_consulta].filter(el => el.selected).length}} {{selecionarTodos[tipo_consulta] || dataMassToSave[tipo_consulta].length>1 ?tipo_consulta :tipo_consulta.replace('s', '').replace('n', 'm')}}</b> 
      - valor total glosado <b>{{getSumGlosa() | formatPrice}}</b>
    </p>
    <v-data-table
      v-model="selecaoTabela"
      :headers="tipo_consulta=='guias'? headersGuia : headersItens"
      :items="listaTemporaria"
      :item-class="(item) => item.is_editada==true? 'active' : '' "
      hide-default-footer
      :ref="`${tipo_consulta}ListTable`"
      :class="tipo_consulta=='guias'?'guiasListTable': 'itensListTable'"
      dense
      show-select
      @toggle-select-all="selecionaTodos"
      @item-selected="selecaoUnica"
    >
      <template v-slot:item.estado="{ item }">
          <!--
          <v-tooltip center bottom>
            <template v-slot:activator="{ on, attrs }" class="pa-0">
              <v-icon v-if="item.tipo_pagamento == 0" v-bind="attrs" v-on="on" color="error" :class="item.tem_anexo ? 'pr-1' : 'pr-2 pl-1'" style="font-size:13px !important; transform: rotate(180deg)">fa-reply</v-icon>
              <v-icon v-else v-bind="attrs" v-on="on" color="error" :class="item.tem_anexo ? 'pr-1' : 'pr-2 pl-1'" style="font-size:13px !important; transform: rotate(180deg)">fa-reply-all</v-icon>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              <b>{{ item.tipo_pagamento == 0 ? 'Glosa Regular' : 'Glosa Mantida' }}</b><br>
            </span>
          </v-tooltip>
          -->
          <v-tooltip center bottom>
            <template v-slot:activator="{ on, attrs }" class="pa-0">
              <v-icon v-bind="attrs" v-on="on" :color="getColorStatus(item)" class="pr-1 ml-1" style="font-size:13px !important">fa-circle</v-icon>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              <b>{{ getDescricaoStatus(item)}}</b><br>
            </span>
          </v-tooltip>

          <v-tooltip center bottom>
            <template v-slot:activator="{ on, attrs }" class="pa-0">
              <v-icon v-bind="attrs" v-on="on" :color="'error'" class="pr-0" v-show="item.tem_anexo">fa-exclamation-triangle</v-icon>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              <b>Necessário anexo</b><br>
            </span>
          </v-tooltip>
          <v-tooltip center bottom v-if="item.estorno">
            <template v-slot:activator="{ on, attrs }" class="pa-0">
              <v-icon v-bind="attrs" v-on="on" color="primary" class="pr-1" style="font-size:13px !important">fa-exclamation</v-icon>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              <b>Estorno</b><br>
            </span>
          </v-tooltip>
          <v-tooltip center bottom v-if="item.mensagens && item.mensagens.length > 0">
            <!-- </v-tooltip>v-if="item.mensagens && item.mensagens.length"> -->
            <template v-slot:activator="{ on, attrs }" class="pa-0">
              <v-icon v-bind="attrs" v-on="on" :color="item.status_envio && (item.status_envio == -1 ||item.status_envio == 4) ? 'error':'primary'" class="pr-1" style="font-size:13px !important">fa-exclamation-triangle</v-icon>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              <b>{{((item.status_envio && (item.status_envio == -1 ||item.status_envio == 4))? '': 'Erro corrigido: ') + item.mensagens }}</b><br>
            </span>
          </v-tooltip>
          <v-tooltip bottom open-delay="100" v-if="parametros && parametros.RG_ENVIO_ANEXO && !!item.qtde_anexos && item.qtde_anexos > 0">
          <template v-slot:activator="{ on, attrs }">
            <v-badge 
                overlap
                class="mr-0" 
                style="font-weight: bold"
                color="accent"
                :content="item.qtde_anexos"
              >
            <v-icon
              class="mr-2"
              color="primary"
              small
              v-bind="attrs"
              v-on="on"
              @click="openUpload(item)"
              style="font-size:11px !important"
              >fa-paperclip
            </v-icon>
            </v-badge>
          </template>
          <span
            class="px-3 py-2 ma-0"
            style="
              border: solid 1px #999;
              border-radius: 5px;
              background-color: #fff;
            "
            >{{item.qtde_anexos == 1? '1 anexo' : item.qtde_anexos + ' anexos'}}</span
          >
        </v-tooltip>
      </template>

      <template v-slot:item.numero_guia_prestador="{ item }">
        {{ item.numero_guia_prestador }}<br>
        {{ item.numero_guia_operadora }}
      </template>
      <!--
        {{ _digitado}}
        <v-text-field
          v-if="item.numero_guia_prestador_digitado !=null || item.numero_guia_prestador_digitado==''"
          v-model="item.numero_guia_prestador"
          :disabled="item.selected==true || true"
          class="input-no-border"
          style="padding:0 !important; height: 24px"
          @input="armazenaItem(item, 'numero_guia_prestador_digitado')"
          @blur="armazenaItem(item, 'numero_guia_prestador_digitado')"
          >
         
        </v-text-field>
        <v-text-field
          v-else
          v-model="item.numero_guia_prestador"
          :disabled="item.selected==true || true"
          class="input-no-border"
          style="padding:0 !important; height: 24px"
          @input="item.numero_guia_prestador_digitado = item.numero_guia_prestador; armazenaItem(item, 'numero_guia_prestador_digitado')"
          @blur="armazenaItem(item, 'numero_guia_prestador_digitado')"
          >
        </v-text-field>
      </template>
      -->
      <template v-slot:item.numero_guia_operadora="{ item }">
        {{ item.numero_guia_operadora }} 
        
      </template>
      <!--
        <v-text-field
          v-if="item.numero_guia_operadora_digitado!=null || item.numero_guia_operadora_digitado==''"
          v-model="item.numero_guia_operadora"
          :disabled="item.selected==true || true"
          class="input-no-border"
          style="padding:0 !important; height: 24px "
          @input="armazenaItem(item, 'numero_guia_operadora_digitado')"
          @blur="armazenaItem(item, 'numero_guia_operadora_digitado')"
          >
        </v-text-field>
        <v-text-field
          v-else
          v-model="item.numero_guia_operadora"
          :disabled="item.selected==true || true"
          class="input-no-border"
          style="padding:0 !important; height: 24px "
          @input="item.numero_guia_operadora_digitado = item.numero_guia_operadora; armazenaItem(item, 'numero_guia_operadora_digitado')"
          @blur="armazenaItem(item, 'numero_guia_operadora_digitado')"
          >
        </v-text-field>
      </template>
      -->
      <template v-slot:item.carteira_beneficiario="{ item }">
        <v-tooltip center bottom>
            <template v-slot:activator="{ on, attrs }" class="pa-0">
              <span
              @dblclick="copiarParaClipboard(item.nome_beneficiario, 'Beneficiário')"
          v-bind="attrs"
          v-on="on"
        >{{ item.carteira_beneficiario}} </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              <b>{{ item.nome_beneficiario}}</b><br>
            </span>
          </v-tooltip>
      </template>
      <template v-slot:item.tabela="{ item }">
        <v-tooltip center bottom>
            <template v-slot:activator="{ on, attrs }" class="pa-0">
              <span
              @dblclick="copiarParaClipboard(item.tabela_descricao, 'Tabela')"
          v-bind="attrs"
          v-on="on"
        >{{ item.tabela}} </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              <b>{{ item.tabela_descricao}}</b><br>
            </span>
          </v-tooltip>
      </template>
      <!-- Inicio Tabela Digitado -->
      <template v-slot:item.tabela_digitado="{ item }">
          <template class="pa-0">
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            v-model="item.tabela_digitado"
            :items="dominioTiss['dm_tabela']"
            :disabled="item.selected==true"
            :placeholder="getDescricaoDominioTiss('dm_tabela', item.tabela)"
            outlined
            style="min-width: 180px;"
            class="ma-0"
            item-text="descricao"
            item-value="valor"
            
            @blur="armazenaItem(item, 'tabela_digitado')"
            @change="armazenaItem(item, 'tabela_digitado')"
          ></v-select>
            </template>
      </template>
<!-- Inicio CBOS-->
      <template v-slot:item.cbos="{ item }">
        <v-tooltip center bottom>
            <template v-slot:activator="{ on, attrs }" class="pa-0">
              <span
              @dblclick="copiarParaClipboard(getDescricaoDominioTiss('dm_CBOS',item.cbos), 'CBOS do Profissional executante')"
          v-bind="attrs"
          v-on="on"
        > {{getDescricaoDominioTiss('dm_CBOS', item.cbos)}}</span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              <b>{{ getDescricaoDominioTiss('dm_CBOS', item.cbos)}}</b><br>
            </span>
          </v-tooltip>
      </template>
<!-- Fim CBOS-->
 <!-- Inicio CBOS Digitado-->
      <template v-slot:item.cbos_digitado="{ item }">
          <template class="pa-0">
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            v-model="item.cbos_digitado"
            :items="dominioTiss['dm_CBOS']"
            :disabled="item.selected==true"
            :placeholder="getDescricaoDominioTiss('dm_CBOS', item.cbos)"
            outlined
            style="min-width: 90px;"
            item-text="descricao"
            item-value="valor"
            @blur="armazenaItem(item, 'cbos_digitado')"
            @change="armazenaItem(item, 'cbos_digitado')"
          ></v-select>
            </template>
      </template>
<!-- Fim CBOS Digitado-->
 <!-- Inicio grau_participacao-->
      <template v-slot:item.grau_participacao="{ item }">
        <v-tooltip center bottom v-if="dadosPagamento.operadora_ans_id == 346659"><!-- todas menos CASSi-->
            <template v-slot:activator="{ on, attrs }" class="pa-0">
              <span
              @dblclick="copiarParaClipboard(getDescricaoDominioTiss('dm_grauParticipacao',item.grau_participacao), 'Grau de participacao do Profissional executante')"
          v-bind="attrs"
          v-on="on"
        > {{getDescricaoDominioTiss('dm_grauParticipacao', item.grau_participacao)}}</span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              <b>{{ getDescricaoDominioTiss('dm_grauParticipacao', item.grau_participacao)}}</b><br>
            </span>
          </v-tooltip>
      </template>
<!-- Fim grau_participacao-->
 <!-- Inicio grau_participacao_digitado-->
      <template v-slot:item.grau_participacao_digitado="{ item }">
          <template class="pa-0">
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            v-model="item.grau_participacao_digitado"
            :items="dominioTiss['dm_grauParticipacao']"
            :disabled="item.selected==true"
            :placeholder="getDescricaoDominioTiss('dm_grauParticipacao', item.grau_participacao)"
            outlined
            style="min-width: 90px;"
            item-text="descricao"
            item-value="valor"
            @blur="armazenaItem(item, 'grau_participacao_digitado')"
            @change="armazenaItem(item, 'grau_participacao_digitado')"
          ></v-select>
            </template>
      </template>
<!-- Fim grau_participacao_digitado-->
      <template v-slot:item.codigo_procedimento="{ item }">
        <v-tooltip center bottom>
            <template v-slot:activator="{ on, attrs }" class="pa-0">
              <span
              @dblclick="copiarParaClipboard(item.descricao_procedimento, 'Procedimento/Material')"
          v-bind="attrs"
          v-on="on"
        >{{ item.codigo_procedimento}} </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              <b>{{ item.descricao_procedimento}}</b><br>
            </span>
          </v-tooltip>
      </template>
      <template v-slot:item.codigo_procedimento_digitado="{ item }">
        <v-text-field
          v-model="item.codigo_procedimento_digitado"
          :disabled="item.selected==true"
          class="input-no-border"
          style="padding:0 !important; height: 24px"
          @click="verificaMotivo(item)? verificaMotivoNivel(item): null"
          @doubleclick="verificaMotivo(item)? verificaMotivoNivel(item): null"
          @change="armazenaItem(item, 'codigo_procedimento_digitado')"
          :rules="[formRules.typeNumber]"
          >
        </v-text-field>

      </template>
      <template v-slot:item.data_autorizacao="{ item }">
        {{ item.data_autorizacao | formatDate }}
      </template>
      <template v-slot:item.data_inicio_faturamento="{ item }">
        {{ item.data_inicio_faturamento | formatDate }} 
        {{!!item.data_final_faturamento? 'a': '' }}
        {{ item.data_final_faturamento | formatDate }}
      </template>      
      <template v-slot:item.data_execucao="{ item }">
        {{ item.data_execucao | formatDate }}
      </template>
      <template v-slot:item.valor_unitario="{ item }">
        {{ item.valor_unitario | formatPrice }}
      </template>

      <template v-slot:item.valor_informado="{ item }">
        {{ item.valor_informado | formatPrice }}
      </template>

      <template v-slot:item.valor_liberado="{ item }">
        {{ item.valor_liberado }}
      </template>

      <template v-slot:item.valor_recursado="{ item }" v-if="tipo_consulta=='guias'">
        <span v-if="item.valor_recursado || item.valor_recursado==0"><b>{{ item.valor_recursado | formatPrice }}</b></span>
      </template>
       <template v-slot:item.valor_recursado="{ item }" v-else>
        <v-text-field
          v-model="item.valor_recursado"
          :disabled="item.selected==true"
          class="input-no-border"
          style="padding:0 !important; height: 24px"
          @click="verificaMotivo(item)? verificaMotivoNivel(item): null"
          @doubleclick="verificaMotivo(item)? verificaMotivoNivel(item): null"
          @input="tipo_consulta=='itens'? formatPrice(item, 'valor_recursado'):''"
          @change="armazenaItem(item, 'valor_recursado')"
          :rules="item.justificativa && item.justificativa!=''?[formRules.requiredField, formRules.typeNumber]:[formRules.typeNumber]"
          >
        </v-text-field>
      </template>
       <template v-slot:item.senha="{ item }">
         <v-text-field v-if="tipo_consulta=='guias'"
          :placeholder="item.senha"
          v-model="item.senha_digitado"
          :disabled="item.selected==true"
          class="input-no-border"
          style="padding:0 !important; height: 24px "
          @input="armazenaItem(item, 'senha_digitado')"
          @blur="armazenaItem(item, 'senha_digitado')"
          @dblclick="copiarParaClipboard(item.senha, 'Senha')"
          >
        </v-text-field>
          <span v-else 
          @dblclick="copiarParaClipboard(item.senha, 'Senha')"
          >{{item.senha}}</span>
      </template>
      <template v-slot:item.motivo_glosa_digitado="{ item }">
        <v-text-field
          
          v-model="item.motivo_glosa_digitado"
          :disabled="item.selected==true"
          class="input-no-border validate-field"
          style="padding:0 !important; height: 24px "
          :label="labelValidacao(item, 'motivo_glosa_digitado')"
          @click="verificaMotivo(item)? verificaMotivoNivel(item): null"
          @doubleclick="verificaMotivo(item)? verificaMotivoNivel(item): null"
          @input="armazenaItem(item, 'motivo_glosa_digitado')"
          @blur="armazenaItem(item, 'motivo_glosa_digitado')"
          :rules="(item.motivo_glosa == null || item.motivo_glosa == '') && item.valor_recursado > 0?[formRules.requiredField]:[]"
        >
        </v-text-field>
      <!--
        <v-text-field
          v-if="item.motivo_glosa_digitado==null && tipo_consulta=='itens'"
          v-model="item.motivo_glosa_recurso"
          :disabled="item.selected==true"
          class="input-no-border"
          style="padding:0 !important; height: 24px "
          @input="item.motivo_glosa_digitado = item.motivo_glosa_recurso; armazenaItem(item, 'motivo_glosa_digitado')"
          @blur="armazenaItem(item, 'motivo_glosa_digitado')"
        >
        </v-text-field>
        <v-text-field
          v-if="item.motivo_glosa_digitado==null && tipo_consulta=='guias'"
          v-model="item.motivo_glosa"
          :disabled="item.selected==true"
          class="input-no-border"
          style="padding:0 !important; height: 24px "
          @input="item.motivo_glosa_digitado = item.motivo_glosa; armazenaItem(item, 'motivo_glosa_digitado')"
          @blur="armazenaItem(item, 'motivo_glosa_digitado')"
        >
        </v-text-field>
      -->
      </template>
      <template v-slot:item.motivo_glosa="{ item }">
        <v-tooltip center bottom>
            <template v-slot:activator="{ on, attrs }" class="pa-0">
              <span
              @dblclick="copiarParaClipboard((getDescGlosa(item.motivo_glosa, item)+' - '+item.motivo_glosa), 'Motivo de glosa')"
          v-bind="attrs"
          v-on="on"
        >{{item.motivo_glosa}} </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              <b>{{getDescGlosa(item.motivo_glosa, item)}} - {{item.motivo_glosa}}</b><br>
            </span>
          </v-tooltip>
          
      </template>
      <template v-slot:item.tem_anexo="{ item }">
        <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            v-model="item.tem_anexo"
            item-text="descricao"
            item-value="id"
            :items="[{id: true, descricao:'Sim'}, {id: false, descricao:'Não'}]"
            placeholder="Selecione"
            outlined
            class="mt-2 mb-n5"
            :disabled="item.selected==true"
            @change="armazenaItem(item, 'tem_anexo')"
          ></v-select>
      </template>
       <template v-slot:item.justificativa="{ item }">
        <v-text-field
          v-model="item.justificativa"
          :disabled="item.selected==true"
          :label="labelValidacao(item)"
          class="input-no-border validate-field"
          :rules="verificaVersao()"
          style="padding:0 !important; height: 24px"
          @click="verificaMotivo(item)? verificaMotivoNivel(item): null"
          @doubleclick="verificaMotivo(item)? verificaMotivoNivel(item): null"
          @input="armazenaItem(item, 'justificativa')"
          >
        </v-text-field>
        <!--
          :color="item.valor_recursado!=(tipo_consulta=='guias' ? 0 :'0,00') && !item.justificativa ?'error' :'primary'"
        -->
        </template>
        <!--
        <template v-slot:item.area_geradora="{ item }">
        <v-text-field
          v-model="item.area_geradora"
          :disabled="item.selected==true"
          class="input-no-border"
          style="padding:0 !important; height: 24px "
          @input="armazenaItem(item, 'area_geradora')"
          >
        </v-text-field>
      </template>
      <template v-slot:item.direcionamento="{ item }">
        <v-text-field
          v-model="item.direcionamento"
          :disabled="item.selected==true"
          class="input-no-border"
          style="padding:0 !important; height: 24px "
          @input="armazenaItem(item, 'direcionamento')"
          >
        </v-text-field>
      </template>
      -->
      <template v-slot:item.valor_glosado="{ item }" class="editavel">
        <span style="color:red" v-if="item.valor_glosado || item.valor_glosado==0">{{ item.valor_glosado | formatPrice }}</span>
      </template>
      <template v-slot:item.valor_acatado="{ item }" class="editavel">
        <span style="color:red" v-if="item.valor_acatado || item.valor_acatado==0">{{ item.valor_acatado | formatPrice }}</span>
      </template>
      <template v-slot:item.data-table-update="{ item }">
        <v-menu left offset-x :nudge-width="250" max-width="250px" class="pb-0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" small color="error" :disabled="!ExisteInfoAdicionais(item)" icon>
            <v-icon small color="primary">fa-regular fa-book</v-icon>
            </v-btn>
          </template>
          <v-card class="pb-0">
            <v-card-text>
              <h3>Informações adicionais</h3>
              <br>
              <p>
                <span v-if="item.numero_atendimento">Atendimento nº: <b>{{ item.numero_atendimento }}</b><br></span>
                <span v-if="item.numero_conta_paciente">Conta Paciente nº: <b>{{ item.numero_conta_paciente }}</b><br></span>
                <span v-if="item.numero_remessa">Remessa nº: <b>{{ item.numero_remessa }}</b><br></span>
                <span v-if="item.notas_fiscais">Notas fiscais: <b>{{ item.notas_fiscais }}</b><br></span>
                <span v-if="item.nfe">Notas fiscais eletronicas: <b>{{ item.nfe }}</b><br></span>
              </p>
            </v-card-text>
          </v-card>
        </v-menu>
        <v-menu
        bottom
        origin="center center"
        transition="scale-transition"
        >
          <template v-slot:activator="{ on, attrs }">
          <v-btn
                class="py-0 px-0" 
                color="primary"
                small 
                icon
                v-bind="attrs"
                v-on="on"
                :disabled="item.selected==true"
                >
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
            <v-list>
              <v-list-item v-for="(acao, i) in acoes" :key="i" :disabled="desativaAcoes(acao.acao, item)" @click="acaoClicar(acao.acao, item)">
                <v-list-item-icon class="mr-0"><v-icon small>{{acao.icone}}</v-icon></v-list-item-icon>
                <v-list-item-content>
                <v-list-item-title>{{acao.texto}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
        </v-menu>
      </template>
      <template v-slot:item.dados_extras="{ item }" >
        <!--<v-btn class="py-0 px-0" small @click="abreFormDados(item)"> </v-btn> -->
        <v-tooltip center bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on" :color="updateCorDados(item) ? 'error' : 'primary'" @click="abreFormDados(item)">fa-pen</v-icon>
          </template>  
          <span class="px-1 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
            <b>Adicionar dados extras</b>
          </span>
        </v-tooltip>
      </template> 

    </v-data-table>
    <v-col>
      <v-pagination
        class="no-box-shadow"
        v-model="page"
        :length="pagination.total_pages"
        @input="loading = true; 
        getList(null, page)"
      ></v-pagination>
    </v-col>
    <DadosGuiaDlg
      :close="()=>showDadosGuiaDlg=false"
      :dadosGuia="dadosGuia"
      :dialog="showDadosGuiaDlg"
      :tipoGuia="tipoGuia"
      :dominioTiss="dominioTiss"
    />
    <v-snackbar
    color="success" 
    outlined 
    centered
      v-model="snackbar"
      timeout="1200"
    >
      {{ textCopiado }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="success"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState} from 'vuex'
import DadosGuiaDlg from '@/components/recebiveis/recursos_de_glosa_edicao/DadosGuiaDlg'

export default {
  components:{
    DadosGuiaDlg,
    
  },
  data() {
    return {
      acoesTotal: [
        { acao: 'recursarGlosa', icone:'fa-ban', texto: 'Recursar glosa' },
        { acao: 'acatarGlosa', icone:'fa-check-circle', texto: 'Acatar glosa' },
        { acao: 'openEdicaoIndividual', icone:'fa-edit', texto: 'Editar'},
        { acao: 'openInfoDlg', icone:'fa-eye', texto: 'Ver guia' },
        { acao: 'desfazerEdicaoRecursoConfirm', icone:'fa-history', texto: 'Desfazer alterações' },
        { acao: 'reapresentar', icone:'fa-file-invoice-dollar ', texto: 'Reapresentar' },
//        { acao: 'voltarReapre', icone:'fa-reply ', texto: 'Voltar como glosa' },
        { acao: 'openUpload', icone:'fa-paperclip', texto: 'Anexar arquivo'},
        { acao: 'abreFormDados', icone:'fa-pen', texto: 'Dados Extras' }
      ],
      dadosBasicosGuia: {},
      dadosGuia: null,
      dominioTiss: {},
      listaTemporaria: [],
      loading: false,
      grupo_economico: null,
      headersGuia: [
        { text: "", sortable: false, width: "1px", value: "data-table-select" },        
        { text: "Estado", align: "center", sortable: false,  value: "estado" },
        // { text: "Quant. itens glosados", align: "center", width: "1px", value: "qtd_itens", sortable: false, },
        { text: "Nº guia prestador/\noperadora", value: "numero_guia_prestador", sortable: false, },
        //{ text: "Nº guia operadora", value: "numero_guia_operadora", sortable: false, },
        { text: "Nº do lote", value: "numero_lote", sortable: false, },
        { text: "Data da autorização", align: "center" , value: "data_autorizacao", sortable: false, },
        { text: "Periodo do faturamento", align: "center" , value: "data_inicio_faturamento", sortable: false},
        { text: "Ident. prestador", value: "identificador_prestador_captura", sortable: false, },
        //{ text: "Beneficiário", value: "nome_beneficiario", sortable: false, },
        { text: "Carteirinha", value: "carteira_beneficiario", sortable: false, },
        { text: "Senha", value: "senha", sortable: false },
        { text: "Valor informado (R$)", align: "end" , value: "valor_informado", sortable: false },
        { text: "Valor pago (R$)", align: "end" , value: "valor_liberado", sortable: false },
        { text: "Valor glosado (R$)", align: "end" , value: "valor_glosado", sortable: false },
        { text: "Valor recursado (R$)", align: "end" , value: "valor_recursado", sortable: false },
        { text: "Valor acatado (R$)", align: "end" , value: "valor_acatado", sortable: false },
        { text: "Motivo Glosa Guia", value: "motivo_glosa", align: "left", sortable: false },
        { text: "Motivos Glosa Itens", value: "motivos_glosa", align: "left", sortable: false },
        { text: "Motivo Recurso", value: "motivo_glosa_digitado", align: "left", sortable: false },
        { text: "Justificativa", value: "justificativa", align: "left", sortable: false },
        //{ text: "Anexo", value: "tem_anexo", align: "left", sortable: false },
        //{ text: "Área geradora", value: "area_geradora", align: "left", sortable: false },
        //{ text: "Direcionamento", value: "direcionamento", align: "left", sortable: false },
        //{ text: "Dados Extras", value: "dados_extras", align: "left", sortable: false },
        { text: "Ações", class:"acao", sortable: false, value: "data-table-update" },
      ],
      headersItens: [
        { text: "", sortable: false, width: "1px", value: "data-table-select" },        
        { text: "Estado", sortable: false, width: "1px", value: "estado", align: "center"  },
        { text: "Nº guia prestador/\noperadora", value: "numero_guia_prestador", sortable: false, },
        // { text: "Nº guia operadora", value: "numero_guia_operadora", sortable: false, },
        { text: "Nº do lote", value: "numero_lote", sortable: false, },
        { text: "Data da execução", align: "center" , value: "data_execucao", sortable: false, },
        { text: "Ident. prestador", value: "identificador_prestador_captura", sortable: false, },
        //{ text: "Beneficiário", value: "nome_beneficiario", sortable: false, },
        { text: "Carteirinha", value: "carteira_beneficiario", sortable: false, },
        { text: "Senha", value: "senha", sortable: false },
        { text: "Prof. Executante Demonstrado", value: "profissional_executante_dem", sortable: false },
        { text: "Tabela", value: "tabela", sortable: false, },
        { text: "Código do procedimento", value: "codigo_procedimento", sortable: false, },
        { text: "Cód. do procedimento digitado", value: "codigo_procedimento_digitado", sortable: false, },
        //{ text: "Procedimento/Despesa", value: "descricao_procedimento", sortable: false },
        { text: "Qtde", align: "center", value: "quantidade", sortable: false },
        { text: "Valor unitario (R$)", align: "right" , value: "valor_unitario", sortable: false },
        { text: "Valor informado (R$)", align: "right" , value: "valor_informado", sortable: false },
        { text: "Valor pago (R$)", align: "right" , value: "valor_liberado", sortable: false },
        { text: "Valor glosado (R$)", align: "right" , value: "valor_glosado", sortable: false },
        { text: "Valor recursado (R$)", align: "right" , value: "valor_recursado", sortable: false },
        { text: "Valor acatado (R$)", align: "right" , value: "valor_acatado", sortable: false },
        { text: "Motivo Glosa Guia", value: "motivo_glosa_guia", align: "left", sortable: false },
        { text: "Motivo Glosa Item", value: "motivo_glosa", align: "left", sortable: false },
        { text: "Motivo Recurso", value: "motivo_glosa_digitado", align: "left", sortable: false },
        { text: "Justificativa", value: "justificativa", align: "left", sortable: false },
        { text: "CBOS do executante", value: "cbos", align: "left", sortable: false },
        { text: "Grau de participação", value: "grau_participacao", align: "left", sortable: false },
        //{ text: "Anexo", value: "tem_anexo", align: "left", sortable: false },
        //{ text: "Área geradora", value: "area_geradora", align: "left", sortable: false },
        //{ text: "Direcionamento", value: "direcionamento", align: "left", sortable: false },
        //{ text: "Dados Extras", value: "dados_extras", align: "left", sortable: false },
        { text: "Ações", class:"acao", sortable: false, value: "data-table-update" },
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      selecionarTodos: {
        itens: false,
        guias: false
      },
      ignora_alerta: [],
      selection: null,
      registrosExcluidos: [],
      selecaoTabela: [],
      showDadosGuiaDlg: false,
      textCopiado:"",
      snackbar: false,
      tipoGuia: '',
      tipoguiasList:[],
      valorTotalSelecionado: 0,
      statusColor: [null,'primary', '#cfd403', '#FC9D0A'],
      estado: null,
      dadosExtrasObrigatorios: []
      
    }
  },
  watch: {
    list:{
      deep: true,
      handler(val) {      
        this.listaTemporaria = [];   
        this.loading = false; 
        this.listaTemporaria = val.map(el=> ({...el}))
        this.page = this.pagination.offset
        let listaEdicao = this.dataToSave[this.tipo_consulta]
        if (listaEdicao.length){
          this.listaTemporaria.map( item => {
            let itemEditado = listaEdicao.find(el=> el.id == item.id)
            if(itemEditado!=undefined){
              return Object.assign(item, itemEditado)
            }
            if (this.tipo_consulta == 'itens') {
              this.formatPrice(item, 'valor_recursado', true)
            }
            return item
          })
        }

        let listaEdicaoMassa = this.dataMassToSave[this.tipo_consulta]
        if (listaEdicaoMassa.length==0 && this.selecaoTabela.length>1) {
          this.selecaoTabela = []
          if (this.saveEdicaoEmMassa.update) {
            this.saveEdicaoEmMassa.update = false
            this.selecionaTodos({value: false})
          }
        }
        if (listaEdicaoMassa.length || this.selecionarTodos[this.tipo_consulta]){
          this.listaTemporaria.map( item => {
            let itemEditado = listaEdicaoMassa.find(el=> el.id == item.id)
            if(itemEditado!=undefined){
              return Object.assign(item, itemEditado)
            }
            if (this.selecionarTodos[this.tipo_consulta]) {
              this.selecionaTodos({value: true})
            }
            return item
          })
        }
        this.atualizaAcoes()
        if (this.tipo_consulta == 'itens' && listaEdicao.length==0) {
          for (var itens of this.listaTemporaria ) {
            this.formatPrice(itens, 'valor_recursado', true)
          }
        }
        setTimeout(() => {this.markRowSave()},100)
        this.$nextTick(()=> this.loading = false)

        // this.tipo_consulta == "guias" ? this.acoes[2].texto = 'Ver Itens' : this.acoes[2].texto = 'Ver Guia'
      }
    },
    
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      formRules: (state) => state.formRules,
    }),
    habilitaAnexoMassa: function() { 
      if(!this.filterData.reapresentacao) {
          if(this.parametros && this.parametros.RG_ENVIO_ANEXO ) {
            let rg_anexo_param = JSON.parse(this.parametros.RG_ANEXO_PARAM)
            let niveis = rg_anexo_param.niveis? JSON.parse(rg_anexo_param.niveis) : [];
            if( (this.tipo_consulta == 'guias' && niveis.includes('guia')) 
              || (this.tipo_consulta == 'itens' && niveis.includes('item')))
              {return true}
            else {return false}
          } else {
            return false
          }
        
        }
      else 
      {
        return false
        }
    },
    rg_envia_item_nivel_guia(){
      // Quando a operadora obriga a edição de itens para glosas de guias
      return this.dadosPagamento?.operadora_ans_id == 346659
    }
  },
  beforeMount(){
    this.getTipoGuias();
    this.getDominiosTiss();
    this.atualizaHeaderTabela();
  },
  mounted(){
    this.listaTemporaria = this.list.map(el=> ({...el}))
    this.paramId = this.$route.query.integral? 'pagamento_id': 'pagamento_prestador_identificacao_id'
    this.pagamentoId = this.$route.params.id

    this.operadora_ans_id = this.dadosPagamento.operadora_ans_id
        this.prestador_id = this.dadosPagamento.prestador_id
    
    this.separaDadosExtras()
    this.atualizaAcoes()
  },
  methods: {
    atualizaHeaderTabela(){
      if(this.parametros && this.parametros.RG_CAMPOS_EDITAVEIS ){
        let CamposEditaveis = this.parametros.RG_CAMPOS_EDITAVEIS;
        CamposEditaveis.forEach( campo => {
          let index = this.headersItens.findIndex(x=> x.value == campo);
          if(index > -1){
            let campoEditavel = Object.assign({}, this.headersItens[index])
            campoEditavel.text += " editado"
            campoEditavel.value += "_digitado"
            this.headersItens.splice(index+1, 0, campoEditavel);
          }
        });
      }
    },
    verificaMotivo(item){
        if(!this.filterData.reapresentacao){
          return (this.tipo_consulta == "guias" && !this.motivo_glosa && !this.motivo_glosa_digitado && !this.ignora_alerta.includes(item.id))
          || (this.tipo_consulta == "itens" && !this.motivo_glosa_guia && !this.ignora_alerta.includes(item.recurso_guia_id));
        }
        else 
        return false
    },
    acaoClicar(acao, item){
      if(acao == "acatarGlosa") {
        if(this.tipo_consulta == "guias"){
          item.justificativa = null
        }
        if(this.tipo_consulta == "itens"){
          item.isRecursado = false
        }
        this[acao](item)
      } else if(acao == "recursarGlosa") {
        if(this.tipo_consulta == "itens"){
          item.isRecursado = true
        }
        if(this.verificaMotivo(item))
           this.verificaMotivoNivel(item, acao)
        else 
          this[acao](item)
      } else {
        this[acao](item)
      }
    },
    atualizaAcoes(){
        let temDadosExtras = this.dadosExtras? true : false;
        let removerAcoes = []
        if(this.filterData.reapresentacao) {
            //removerAcoes.push('recursarGlosa')
            //removerAcoes.push('acatarGlosa')
            removerAcoes.push('openUpload')
            if(!(temDadosExtras && this.dadosExtras.Reapresentacao))
              removerAcoes.push('abreFormDados')
        } else if(this.parametros && this.parametros.RG_ENVIO_ANEXO ) {
          let rg_anexo_param = JSON.parse(this.parametros.RG_ANEXO_PARAM)
          let niveis = rg_anexo_param.niveis? JSON.parse(rg_anexo_param.niveis) : [];
          if(!((this.tipo_consulta == 'guias' && niveis.includes('guia')) || (this.tipo_consulta == 'itens' && niveis.includes('item'))))
            removerAcoes.push('openUpload')
        } else {
            removerAcoes.push('openUpload')
        }
        if (this.filterData.tipo_pagamento == 10 || (this.parametros && !this.parametros.RG_REAPRESENTACAO)) {
            removerAcoes.push('reapresentar')
        }
        
        if(!this.filterData.reapresentacao && !(temDadosExtras && this.dadosExtras.Recurso)){
          removerAcoes.push('abreFormDados')
        }

        this.acoes = this.acoesTotal.reduce((acum, el)=>{
          if(!removerAcoes.includes(el.acao)){
            acum.push(el)
          }
          return acum
        }, [])
        let indReap = this.acoes.findIndex(el=> el.acao == 'reapresentar')
        if(indReap > -1)
        this.filterData.reapresentacao? this.acoes[indReap].texto = 'Voltar como glosa' : this.acoes[indReap].texto = 'Reapresentar'
        
        let ind = this.acoes.findIndex(el=> el.acao == 'openInfoDlg')
        if(ind > -1)
          this.tipo_consulta == "guias" ? this.acoes[ind].texto = 'Ver Itens' : this.acoes[ind].texto = 'Ver Guia'
        
        let ind2 = this.acoes.findIndex(el=> el.acao == 'recursarGlosa')
        if(ind2 > -1)
          this.filterData.reapresentacao ? this.acoes[ind2].texto = 'Reapresentar Glosa' : this.acoes[ind2].texto = 'Recursar Glosa'
    },
    copiarParaClipboard(texto, campo) {
      this.textCopiado = campo + " " + texto + ", copiado!"
      navigator.clipboard.writeText(texto);
      this.snackbar = true;
    },
    getDescGlosa(id, item){
      if (this.tipo_consulta=='guias') {
        let motivosList = JSON.parse(JSON.stringify(this.motivosGlosaList));
        let ind = motivosList.findIndex(el=> el.motivo_glosa == id)
        if(ind > -1)
          return motivosList[ind].descricao_motivo_glosa
        else 
          return ""
      }
      else {
        return item.descricao_motivo_glosa
      }
    },
    desativaAcoes(acao, item) {      
      if(acao == 'recursarGlosa' && item.valor_recursado != (this.tipo_consulta=='guias' ?0 :'0,00') && item.valor_acatado==0){
        return true
      }
      if(acao == 'acatarGlosa' && item.valor_acatado!=0 && item.valor_recursado == (this.tipo_consulta=='guias' ? 0 : '0,00')){
        return true
      }
      if(acao == 'reapresentar' && (item.tipo_guia != "2" && this.parametros && !this.parametros.RG_REAPRESENTACAO_BLOQUEIA_XML)){
        return true
      }
      return false
    },
    ExisteInfoAdicionais(item) {
      let exibeInfoAdicionais = ((item.numero_atendimento != '' && item.numero_atendimento != null) ||
                                  (item.numero_conta_paciente != '' && item.numero_conta_paciente != null) ||
                                  (item.numero_remessa != '' && item.numero_remessa != null) || 
                                  (item.notas_fiscais != '' && item.notas_fiscais != null) || 
                                  (item.nfe != '' && item.nfe != null));
      return exibeInfoAdicionais;
    },
    confirmSaveEdicoesIndividuais() {
      let qtd_erro = 0
      let faltaDadosExtras = 0
      let ignorarValidacoes = this.parametros 
                              && this.parametros.RG_REAPRESENTACAO_BLOQUEIA_XML 
                              && this.filterData.reapresentacao
                              && this.dadosPagamento.prestador_id == 293
                              && this.dadosPagamento.operadora_ans_id == 421715;
      if(!ignorarValidacoes){
      this.dataToSave[this.tipo_consulta].forEach(e => {
        
        console.log('confirmSaveEdicoesIndividuais')
        if(!(this.filterData.reapresentacao 
              && this.parametros 
              && this.parametros.RG_REAPRESENTACAO_BLOQUEIA_XML
              && this.dadosPagamento.prestador_id == 293
              && this.dadosPagamento.operadora_ans_id == 421715)) {
          if(((parseFloat(e.valor_recursado) > 0 && this.tipo_consulta == "guias") || (e.valor_recursado != '0,00' && this.tipo_consulta == "itens")) && (e.justificativa == null || e.justificativa == "")){
            qtd_erro++
          } 
          else if(parseFloat(e.valor_recursado) > 0 && (e.justificativa != null || e.justificativa != ""))
          {
            if(this.parametros && this.parametros.RG_QTD_CARACTERES_JUSTIFICATIVA && e.justificativa.length > this.parametros.RG_QTD_CARACTERES_JUSTIFICATIVA){
                  qtd_erro++
            } else if(this.parametros && this.parametros.RG_Versao && this.parametros.RG_Versao >= 40000){
                if(e.justificativa.length > 500) 
                  qtd_erro++
            } else if(e.justificativa.length > 150) {
                  qtd_erro++
            }
  
          }
          if(this.dadosExtrasObrigatorios && this.dadosExtrasObrigatorios.length > 0){
  
            if(JSON.parse(e.dados_extras).Dados == undefined){
              faltaDadosExtras++
            } else {
              JSON.parse(e.dados_extras).Dados.Recurso.campo.forEach(ele => {
                this.dadosExtrasObrigatorios.forEach(elems => {
                  if(ele['Nome'] == elems && ele['Valor'] == ''){
                    faltaDadosExtras++
                  }
                })
              })
            }
          }
        }
      });
      }
      if(qtd_erro > 0){
        
        let paramModal = {
            type: "warning",
            title: `${qtd_erro==1 ?'Existe' :'Existem'} ${qtd_erro} ${qtd_erro==1 ? `${this.tipo_consulta.replace('s','').replace('n','m')}`:`${this.tipo_consulta}`} sem Justificativa`,
            message: "A justificativa apresentada não se enquadra nos padrões exigidos.",
            callback: null,
            btConfirm: { name: "Ok", show: true },
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
          
      } else if(faltaDadosExtras > 0){
        
        let paramModal = {
            type: "warning",
            title: `${faltaDadosExtras==1 ?'Existe' :'Existem'} ${faltaDadosExtras} ${faltaDadosExtras==1 ? `${this.tipo_consulta.replace('s','').replace('n','m')}`:`${this.tipo_consulta}`} sem Dados Extras`,
            message: "Necessario ter Dados Extras para prosseguir.",
            callback: null,
            btConfirm: { name: "Ok", show: true },
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
          
      
      } else {

        let qtd_sem_recursar_acatar = this.dataToSave[this.tipo_consulta].filter(el => el.valor_acatado == 0 && el.valor_recursado == (this.tipo_consulta=='guias' ?0 :'0,00')).length
        if(this.dataToSave[this.tipo_consulta].length) {
          let paramModal = {
            type: qtd_sem_recursar_acatar>0 ?'warning' :"info",
            title: qtd_sem_recursar_acatar>0 ?`${qtd_sem_recursar_acatar==1 ?'Existe' :'Existem'} ${qtd_sem_recursar_acatar} ${qtd_sem_recursar_acatar==1 ?this.tipo_consulta.replace('s','').replace('n','m') :this.tipo_consulta} para ${this.tipo_consulta=='guias' ?qtd_sem_recursar_acatar==1 ?'ser analisada' :'serem analisadas' :qtd_sem_recursar_acatar==1 ?'ser analisado' :'serem analisados'}` :"Deseja salvar as edições efetuadas?",
            message: qtd_sem_recursar_acatar>0 ?'Os recursos de glosa so serão considerados quando acatado ou recursado.<br/> Deseja prosseguir?  ' :"As edições serão salvas, mas o recurso continuará alocado para o seu usuário.",
            callback: () => this.saveEdicoes(true),
            btConfirm: { name: "Salvar", show: true },
            btCancel: { name: 'Cancelar', show: true }
          }
          if (this.rg_envia_item_nivel_guia) {
            paramModal.message = (this.tipo_consulta == "itens"? "Edite a senha da(s) guia(s), se necessário.<br><br>" : "Após salvar a edição da(s) guia(s), justifique os itens para continuar com o recurso.<br><br>") + paramModal.message;
            paramModal.btConfirm = { name: "Ok", show: true};
            paramModal.btCancel = null;
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
        }
      }

    },
    armazenaItem(item, campo) {
      let ind = this.listaTemporaria.findIndex(el=> el.id == item.id)
      let validate = false
      let valida_motivo = false
      if(!(this.filterData.reapresentacao 
            && this.parametros 
            && this.parametros.RG_REAPRESENTACAO_BLOQUEIA_XML
            && this.grupo_economico == 1)) {
        validate = item.valor_recursado!=(this.tipo_consulta=='guias' ? 0 :'0,00') && !item.justificativa
        valida_motivo = item.valor_recursado!=(this.tipo_consulta=='guias' ? 0 :'0,00') && !item.motivo_glosa && !item.motivo_glosa_digitado
      }
      if(ind>-1 && this.listaTemporaria[ind][campo] != this.list[ind][campo]) {
        if (item.status_analise==2 && !item.reedicao) {
          let paramModal = {
            type: "info",
            title: this.tipo_consulta=='guias' ?'Edição de Guias analisadas' :'Edição de itens analisados',
            message: `${this.tipo_consulta=='guias' ?`Essa guia possui <b>${item.qtd_itens_editados}</b> ${item.qtd_itens_editados==1 ?'item' :'itens'} já analisados de um total de <b>${item.qtd_itens}</b> ${item.qtd_itens==1 ?'item' :'itens'}` :'Esse item pertence a uma guia já analisada'},<br/> caso prossiga com a edição as alterações realizadas serão perdidas.<br/> Deseja continuar?`,
            callback: () => {
              item.reedicao = 1
              this.updateDataToSave(item, this.tipo_consulta)
              this.markRow(true, ind, validate, valida_motivo)
            },
            btConfirm: { name: "sim", show: true },
            btCancel: { name: 'não', show: true, callback: () => {this.desfazerAlteracoes(item)}}
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        } else {
          this.updateDataToSave(item, this.tipo_consulta)
          this.markRow(true, ind, validate, valida_motivo)
        }
      } else {
        this.markRow(true, ind, validate, valida_motivo)
      }
    },
    markRowSave() {
      let validaJustificativa = this.verificaVersao().length > 0
      let listRequiredFields = this.listaTemporaria.filter( el => el.valor_recursado!= (this.tipo_consulta=='guias' ?0 :'0,00') && ((!el.justificativa && validaJustificativa) || (!el.motivo_glosa && !el.motivo_glosa_digitado)))
      if (this.dataToSave[this.tipo_consulta].length) {
        for (var item of this.dataToSave[this.tipo_consulta]) {
          let index = this.listaTemporaria.findIndex(el=> el.id == item.id && ((!this.dataMassToSave[this.tipo_consulta].filter(el => el.id == item.id).length > 0 && !this.selecionarTodos[this.tipo_consulta]) || (this.dataMassToSave[this.tipo_consulta].filter(el => el.id == item.id).length > 0 && this.selecionarTodos[this.tipo_consulta])))
          let validate = item.valor_recursado!=(this.tipo_consulta=='guias' ?0 :'0,00') && !item.justificativa
          let validaMotivo = item.valor_recursado!=(this.tipo_consulta=='guias' ?0 :'0,00') && !item.motivo_glosa && !item.motivo_glosa_digitado
          if (index > -1) 
            this.markRow(true, index, validate, validaMotivo)
        }
      } else if (!this.selecionarTodos[this.tipo_consulta] && this.dataMassToSave[this.tipo_consulta].length == 0) {
        this.$refs[`${this.tipo_consulta}ListTable`].$el.querySelectorAll('tr').forEach(el =>el.removeAttribute('class', 'active'))
      } 
      if (listRequiredFields.length) {
        listRequiredFields.forEach(item => {
          let index = this.listaTemporaria.findIndex(el=> el.id == item.id && !this.dataToSave[this.tipo_consulta].filter(el => el.id == item.id).length > 0 && ((!this.dataMassToSave[this.tipo_consulta].filter(el => el.id == item.id).length > 0 && !this.selecionarTodos[this.tipo_consulta]) || (this.dataMassToSave[this.tipo_consulta].filter(el => el.id == item.id).length > 0 && this.selecionarTodos[this.tipo_consulta])))
          if (index > -1) 
            this.markRowObritatorio(item, index)
        })
      }
    },
    markRowObritatorio(item, index) {
      if(!(this.filterData.reapresentacao 
            && this.parametros 
            && this.parametros.RG_REAPRESENTACAO_BLOQUEIA_XML
            && this.dadosPagamento.prestador_id == 1)){
        if (item.valor_recursado != (this.tipo_consulta=='guias' ? 0 :'0,00') && !item.justificativa) 
          this.$refs[`${this.tipo_consulta}ListTable`].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].setAttribute('class', 'valid-obrigatorio')
        if (item.valor_recursado != (this.tipo_consulta=='guias' ? 0 :'0,00') && !item.motivo_glosa && !item.motivo_glosa_digitado) 
          this.$refs[`${this.tipo_consulta}ListTable`].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].setAttribute('class', 'valid-obrigatorio')
      }
    },
    markRow(markOnOff, index, validate, valida_motivo) {
      let classeMotivo = valida_motivo? " validate17" : ""
      let classe = validate? "validate" + classeMotivo : classeMotivo;
      (validate || valida_motivo)
      ? this.$refs[`${this.tipo_consulta}ListTable`].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].setAttribute('class', classe)
      :markOnOff 
      ? this.$refs[`${this.tipo_consulta}ListTable`].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].setAttribute('class', 'active') 
      : this.$refs[`${this.tipo_consulta}ListTable`].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].removeAttribute('class', 'active')
      
    },
    getDominiosTiss(){
       let obj = {
              query: [
                {
                  Modulo: "Recebiveis",
                  Acao: "getdominiotiss",
                  Payload: { 
                    grupo_economico: this.grupoEconomico, 
                    versao_tiss: "4.01.00"}
                },
              ],
              noLoader: true
            }
              this.$store.dispatch("request/doRequest", obj).then((response) => {
              if (!response || response.isAxiosError || response.error) {
                this.$store.commit("hideLoader")
                return
              }
              this.dominioTiss = response.dados? response.dados.reduce((dominioTiss, list ) => {
                dominioTiss[list.dominio] = list.valores
                dominioTiss[list.dominio].map(x=> x.descricao = x.valor + " - " + x.descricao)
                // Ajuste porque o javascript considera 0 == nulo
                // if(list.dominio =="dm_grauParticipacao"){
                //   dominioTiss[list.dominio].map(x=> x.valor = "'"+ x.valor+"'");
                // }

                dominioTiss[list.dominio].unshift({valor: null, descricao: "-"})

                return dominioTiss
              },{}):{}
            })
    },
    getDescricaoDominioTiss(dominio, valor){
      if(dominio == "dm_tabela" && valor =="0"){
           valor = "00";
        } 
      let descricao = "";
      if(valor != null){
          descricao = this.dominioTiss[dominio].filter(x=> x.valor== valor)[0].descricao;
      }
      return descricao
    },
    getStatus(item){
      
      let dados = []
      let color = ""
      let legenda = ""
      
      if(this.tipo_consulta == 'guias'){
        
        if(item.flag_recurso_guia == true){ //guia analisada
          color = this.estadoList[0].cor
          legenda = this.estadoList[0].descricao
          dados.push(color)
          dados.push(legenda)
          return dados
        } 

        if((item.qtd_itens == item.qtd_itens_editados) && item.flag_recurso_guia == false){ //todos itens analisados
          color = this.estadoList[1].cor
          legenda = this.estadoList[1].descricao
          dados.push(color)
          dados.push(legenda)
          return dados
        }

        if((item.qtd_itens_editados >= 1) && item.flag_recurso_guia == false){    //Alguns itens analisados
          color = this.estadoList[2].cor
          legenda = this.estadoList[2].descricao
          dados.push(color)
          dados.push(legenda)
          return dados
        }

        if(item.qtd_itens_editados == 0){ //aguardando analise
          color = this.estadoList[3].cor
          legenda = this.estadoList[3].descricao
          dados.push(color)
          dados.push(legenda)
          return dados
        }

      }else if(this.tipo_consulta == 'itens'){
        
        if(item.flag_recurso_guia == true){ //guia analisada
          color = this.estadoList[0].cor
          legenda = this.estadoList[0].descricao
          dados.push(color)
          dados.push(legenda)
          return dados
        }
        
        if(item.flag_recurso_guia == false && (item.valor_recursado != "0,00" || item.valor_acatado != 0)){ //Item analisado
          color = this.estadoList[1].cor
          legenda = this.estadoList[1].descricao
          dados.push(color)
          dados.push(legenda)
          return dados
        }

        else{
          color = this.estadoList[2].cor
          legenda = this.estadoList[2].descricao
          dados.push(color)
          dados.push(legenda)
          return dados
        }
      }
    },
    getColorStatus(item){
      let color = this.getStatus(item)[0]
      return color
      
    },
    getDescricaoStatus(item){
      let legenda = this.getStatus(item)[1]
      return legenda
      
    },
    getTipoGuias() {
      let obj = {
        query: [
          {
            Modulo: "Portal",
            Acao: "gettipoguias",
            Payload: { grupo_economico: this.grupoEconomico, modulo_guia: "faturamento"}           
          },
        ],
        noLoader: true
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
        this.tipoguiasList = response.dados
        this.tipoguiasList.unshift({id: null, descricao: "Selecione"})
      })
    },
    getSumGlosa(){
      let total;
      if (!this.selecionarTodos[this.tipo_consulta]) {
        total = this.dataMassToSave[this.tipo_consulta].reduce((sum, item) => sum + item.valor_glosado, 0)
      } else {
        total = this.valorGlosadoTotal - this.dataMassToSave[this.tipo_consulta].reduce((sum, item) => sum + item.valor_glosado, 0)
      }
      return total
    },
    openInfoDlg(item) {
      if(this.tipo_consulta == "guias"){
        this.filterData.tipo_consulta = "itens"
        this.filterData.numero_guia = item.numero_guia_prestador
        this.getList(this.filterData, 1)
      } else {
        this.filterData.numero_guia = item.numero_guia_prestador
        this.filterData.tipo_consulta = "guias"
        this.getList(this.filterData, 1)
      }

      
      
      /*
      let guia_id = item.faturamento_guia_id
      let obj = {
        query: [
          {
            Modulo: "Faturamento",
            Acao: "getguia",
            Payload: { grupo_economico: this.grupoEconomico, guia_id},
            //noLoader: true
          },
        ],
      }

      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader")
          return
        }
        
        this.dadosGuia = response.guia_json.length ? JSON.parse(response.guia_json) : null

        if(this.dadosGuia == null){
          
          let paramModal = {
            type: "error",
            title: 'Guia não encontrada',
            message: '',
            callback: () => {
              return
            },
            btConfirm: { name: "Ok", show: true },
            btCancel: { name: 'não', show: false }
          }
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          return
        }

        this.tipoGuia = this.tipoguiasList.find(el=> el.id == response.tipo_guia).descricao
        let versao_tiss = response.versao_tiss
        this.showDadosGuiaDlg =  true
        return versao_tiss

      }).then(versao_tiss => {

        if( this.dadosGuia ){
            let obj = {
              query: [
                {
                  Modulo: "Recebiveis",
                  Acao: "getdominiotiss",
                  Payload: { grupo_economico: this.grupoEconomico, versao_tiss: versao_tiss}
                },
              ],
              noLoader: true
            }
              this.$store.dispatch("request/doRequest", obj).then((response) => {
              if (!response || response.isAxiosError || response.error) {
                this.$store.commit("hideLoader")
                return
              }
              this.dominioTiss = response.dados? response.dados.reduce((dominioTiss, list ) => {
                dominioTiss[list.dominio] = list.valores
                return dominioTiss
              },{}):{}
              this.showDadosGuiaDlg =  true
            })
          }
        }) 
       */
    },
    verificaMotivoNivel(item, acao){
        let paramModal = {
              type: "warning",
              title: '',
              message: '',
              callback: () => {
                this.ignora_alerta.push(this.tipo_consulta == "guias"?item.id:item.recurso_guia_id);
                if(acao)
                  this[acao](item);
              },
              btConfirm: { name: "Sim", show: true },
              btCancel: { name: 'Não', show: true }
            }
        if (this.rg_envia_item_nivel_guia) {
          paramModal.title = this.tipo_consulta == "itens"? "Edição dos itens!": "Edição da guia!";
          paramModal.message = this.tipo_consulta == "itens"? "Edite a senha da Guia, se necessário." : "Após salvar a edição da guia, justifique os itens da Guia para continuar com o recurso.";
          paramModal.btConfirm = { name: "Ok", show: true};
          paramModal.btCancel = null;
        } else if(this.tipo_consulta == "guias" && (item.motivo_glosa == '' || !item.motivo_glosa )){
          paramModal.title = "Glosa aplicada pela operadora no item!";
          paramModal.message = "Deseja continuar a execução do recurso de glosa no nível de guia?"
        } else if (this.tipo_consulta == "itens" && (!!item.motivo_glosa_guia && item.motivo_glosa_guia  != '' )) {
          paramModal.title = "Glosa aplicada pela operadora na guia!";
          paramModal.message = "Deseja continuar a execução do recurso de glosa no nível de item?"  
        } else {
            if(acao)
              this[acao](item);
            return
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);

    },
    acatarGlosa(item){
      item.valor_recursado = 0
      this.formatPrice(item, 'valor_recursado')
      item.valor_acatado = item.valor_glosado
      this.updateDataArmazena(item)
    },
    recursarGlosa(item){
      let val = (Number(item.valor_glosado.toString().replace(',', '.'))/1).toFixed(2).replace('.', ',')
      item.valor_recursado = this.tipo_consulta == 'itens' 
      ? val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      :item.valor_glosado
      item.valor_acatado = 0
      this.updateDataArmazena(item)
    },
    updateDataArmazena(item) {
      this.armazenaItem(item, 'valor_recursado')
      this.armazenaItem(item, 'valor_acatado')
    },
    desfazerAlteracoes(item){
      if (!item) {
        this.$refs[`${this.tipo_consulta}ListTable`].$el.querySelectorAll('tr').forEach(el =>el.removeAttribute('class', 'active'))
        this.selecionaTodos({value: false})
        this.dataToSave[this.tipo_consulta] = []
        this.getList(this.filterData, 1)
      } else {
        let parametros = Object.keys(item)
        let index = this.list.findIndex(el=> el.id == item.id)
        let itemOriginal = this.list[index]
        itemOriginal.valor_recursado != 0 && !itemOriginal.justificativa ?this.markRowObritatorio(itemOriginal, index) :this.markRow(false, index)
        this.formatPrice(itemOriginal, 'valor_recursado', true)
        this.dataToSave[this.tipo_consulta] = this.dataToSave[this.tipo_consulta].filter(el => el.id != item.id)
        parametros.forEach(param =>  item[param] = itemOriginal[param]? itemOriginal[param] :itemOriginal[param]==false ?false :null )
        if (this.tipo_consulta == 'guias') {
          item.valor_recursado = itemOriginal.valor_recursado
        }
      }
    },
    desfazerEdicaoRecursoConfirm(data, selecionarTodos, seDesfazerEmMassa){
      let desfazerConfirm = this.desfazerEdicaoRecursoConfirm
      let mensagem = this.tipo_consulta == "guias"?
                    'As análises das guias selecionadas e seus respectivos itens serão excluídas' :
                    'As análises dos itens selecionados e suas respectivas guias serão excluídas'
      let paramModal = {
        type: "warning",
        title: "Deseja desfazer as alterações?",
        message: mensagem,
        messageForm: (text) => {
            if(text.toUpperCase()!="APAGAR")
            {
              let paramModal2 = {
                type: "warning",
                title: "Atenção!",
                message: "Necessário digitar APAGAR para excluir as análises.",
                btConfirm: { name: "Ok", show: true},
                callback: () => setTimeout(()=>{desfazerConfirm(data, selecionarTodos, seDesfazerEmMassa)}, 100)
              }
              this.$store.commit("confirmMessage/showConfirmMessage", paramModal2)
            } else {
              this.desfazerEdicaoRecurso(data, selecionarTodos, seDesfazerEmMassa)
            }
          },
        textForm: { label: "", title: "Confirme digitando APAGAR",  show: true },
        btConfirm: { name: "Confirmar", show: true, color:"warning" },
        btCancel: { name: 'Cancelar', show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
    },
    selecionaTodos(selection) {
      if (selection.value){  
        if (!this.selecionarTodos[this.tipo_consulta]) {
          this.dataMassToSave[this.tipo_consulta] = []
        }
        this.selecionarTodos[this.tipo_consulta] = true
        this.listaTemporaria.forEach(el => {
          el.selected = this.dataMassToSave[this.tipo_consulta].find(opt => opt.id == el.id) ?false :true
          if (el.selected) { this.selecaoTabela.push(el) }
        })
      } else {
        this.selecionarTodos[this.tipo_consulta] = false
        this.listaTemporaria.map(el => el.selected = false)
        this.selecaoTabela = []
        this.dataMassToSave[this.tipo_consulta] = []
        setTimeout(() => {this.markRowSave()},100)
      }
    },
    reapresentar(selection){
      let guia_id = selection.id
      let reapresentar =  !this.filterData.reapresentacao
      if(this.tipo_consulta == 'itens') {
        guia_id = selection.recurso_guia_id
      }
      let obj = {
              query: [
                {
                  Modulo: "Recebiveis",
                  Acao: "updateReapresentacao",
                  Payload: { 
                    grupo_economico: this.grupoEconomico, 
                    operadora_ans_id:this.dadosPagamento.operadora_ans_id,
                    prestador_id:this.dadosPagamento.prestador_id,
                    pagamento_id:this.dadosPagamento.id,
                    guia_id,
                    reapresentar
                    }
                },
              ],
            }
              this.$store.dispatch("request/doRequest", obj).then((response) => {
              if (!response || response.isAxiosError || response.error) {
                this.$store.commit("hideLoader")
                return
              }
              //Retirar o item da lista.
              let ind = -1
              if(this.tipo_consulta == 'itens') {
                guia_id = selection.recurso_guia_id
                let listItems = this.listaTemporaria.filter(el=> el.recurso_guia_id= guia_id)
                listItems.forEach(item =>{
                  ind = this.listaTemporaria.findIndex(el=> el.id = item.id)
                  this.listaTemporaria.splice(ind, 1)
                });
              } else {
                ind = this.listaTemporaria.findIndex(el=> el.id = selection.id)
                this.listaTemporaria.splice(ind, 1)
              }
              this.getGuiasAnalisadas()
            })
    },
    selecaoUnica(selection) {
      if (!this.selecionarTodos[this.tipo_consulta]) {
        let ind = this.dataMassToSave[this.tipo_consulta].findIndex( item => item.id == selection.item.id)
        if (selection.value && ind < 0) {
          selection.item.selected = true
          this.dataMassToSave[this.tipo_consulta].push(selection.item)
        } else if (!selection.value && ind>-1){
          selection.item.selected = false
          this.dataMassToSave[this.tipo_consulta].splice(ind, 1)
          setTimeout(() => {this.markRowSave()},100)
        }
      } else {
        let ind = this.dataMassToSave[this.tipo_consulta].findIndex( item => item.id == selection.item.id)
        if (!selection.value && ind < 0) {
          selection.item.selected = false
          this.dataMassToSave[this.tipo_consulta].push(selection.item)
          setTimeout(() => {this.markRowSave()},100)
        } else if (selection.value && ind>-1){
          selection.item.selected = true
          this.dataMassToSave[this.tipo_consulta].splice(ind, 1)
        }
      }
    },
    formatPrice(item, param, padrao) { 
      if (this.tipo_consulta == 'itens') {
        let value = !isNaN(parseFloat(item[param])) && isFinite(item[param]) 
          ?(Number(item[param].toString().replace(',', '.'))/1).toFixed(2).replace(/[^\d]+/g,'') 
          :item[param].toString().replaceAll(/(!\d|\.|,)/g, '')
        let recurso = Number((Number(value)/100).toFixed(2))
        recurso = recurso > item.valor_glosado ? item.valor_glosado : recurso
        item.valor_acatado = padrao? item.valor_acatado : item.valor_glosado - recurso
        let val = (Number(recurso.toString().replace(',', '.'))/1).toFixed(2).replace('.', ',')
        let result = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        //item[param] = result;
        if (recurso >= item.valor_glosado) 
           setTimeout(() => {item[param] = result}, 10)
        else 
           item[param] == '0,0' || item[param] == '0,000' ?setTimeout(() => {item[param] = result},10) :item[param] = result
      } 
      // else if(this.tipo_consulta == 'guias' && item.valor_recursado == null){
      //     item.valor_recursado = 0
      // }
    },
    separaDadosExtras(){
      let tipoDados = this.filterData.reapresentacao? "Reapresentacao" : "Recurso"
      this.dadosExtrasObrigatorios = (this.dadosExtras && this.dadosExtras[tipoDados] && this.dadosExtras[tipoDados].campo && this.dadosExtras[tipoDados].campo.length > 0) ? 
      this.dadosExtras[tipoDados].campo.filter(ele => Number(ele.Requerido) == 1) : null;

       if(this.dadosExtrasObrigatorios && this.dadosExtrasObrigatorios.length > 0){
          this.dadosExtrasObrigatorios = this.dadosExtrasObrigatorios.map(elem => elem.Nome.toUpperCase())
      }
    },
    updateCorDados(item){
      let resp = true
      if(this.dadosExtrasObrigatorios.length > 0 && (
          (this.tipo_consulta=='guias' && (item.valor_recursado != 0 || item.valor_acatado != 0)) || 
          (this.tipo_consulta=='itens' && (item.valor_recursado != '0,00' || item.valor_acatado != 0))    )
        ){
        
        if(JSON.parse(item.dados_extras).Dados == undefined){
          resp = true

        } else {

          JSON.parse(item.dados_extras).Dados.Recurso.campo.forEach(ele => {
            
            this.dadosExtrasObrigatorios.forEach(e => {
              if(ele.Nome == e && ele.Valor == ''){
                resp = true
              } else {
                resp = false
              }
            })
          })
        }
      } else {
        resp = false
      }
      
      return resp
      
    },
    labelValidacao(item, campo){
      if(this.filterData.reapresentacao 
      && this.parametros 
      && this.parametros.RG_REAPRESENTACAO_BLOQUEIA_XML
      && this.grupo_economico == 1)
      {
        return ""
      
      } else if(campo == "motivo_glosa_digitado") {
        if(this.tipo_consulta=='guias'){
          if(item.valor_recursado != 0  && !item.motivo_glosa && !item.motivo_glosa_digitado)
          return "campo obrigatorio"
        } else {
          if(item.valor_recursado != "0,00" && !item.motivo_glosa && item.motivo_glosa_digitado == '')
          return "campo obrigatorio"
        }
        return ""

      } else {

        if(this.tipo_consulta=='guias'){
          if(item.valor_recursado != 0  && !item.justificativa)
          return "campo obrigatorio"
        } else {
          if(item.valor_recursado != "0,00"  && !item.justificativa)
          return "campo obrigatorio"
        }
        return ""
      }
    },
    verificaVersao(){
      if(this.filterData.reapresentacao 
          && this.parametros 
          && this.parametros.RG_REAPRESENTACAO_BLOQUEIA_XML
          && this.dadosPagamento.prestador_id == 293
          && this.dadosPagamento.operadora_ans_id == 421715)
      {
        return []
      } else if (this.parametros && this.parametros.RG_QTD_CARACTERES_JUSTIFICATIVA){
          return [this.formRules.maxLengthRule(this.parametros.RG_QTD_CARACTERES_JUSTIFICATIVA)]
      } else if(this.parametros && this.parametros.RG_Versao && this.parametros.RG_Versao >= 40000){
          return [this.formRules.max500]
      } else {
          return [this.formRules.max150]
      }
    },
    downloadFile() {
        this.$store.commit("showLoader", { circle: true }, {root: true});
        let Payload = {grupo_economico: this.grupoEconomico, ...this.filterData}
        Payload[this.paramId] = this.pagamentoId
        let modulo = "Recebiveis" 
        let acao = this.tipo_consulta == "guias"? "getcsvguiasrecursoglosaedicao" : "getcsvitensrecursoglosaedicao"
        this.$store.dispatch("documents/getDocumentPost", { Payload, acao, callback: ()=> setTimeout(()=>{this.$store.commit('hideLoader')}, 200), modulo}, {root:true})
    },
    getSelectList(nome_campo){
      let ind = this.getListIndex(nome_campo)
      return ind!=null? this.dominiosList[ind].valores : []
    },
    getListName(nome_campo){
      let campoObj = this.getCampoObj(nome_campo)
      return  campoObj!=undefined? campoObj.nome_dominio : null
    },
    getListIndex(nome_campo){
      let nome_dominio = this.getCampoObj(nome_campo)? this.getCampoObj(nome_campo).nome_dominio : null
      let index = nome_dominio? this.dominiosList.findIndex(el => el.dominio == nome_dominio) : null
      return  index
    },
  },
  props: {
    dataToSave: Object,
    dataMassToSave: Object,
    anexarEmMassa: Function,
    edicaoEmMassa: Function,
    openGestao: Function,
    saveEdicaoEmMassa: Object,
    getList: Function,
    list: Array,
    openJustificativaDlg: Function,
    openUpload: Function,
    openEdicaoIndividual: Function,
    pagination: Object,
    tipo_consulta: String,
    updateDataToSave: Function,
    saveEdicoes: Function,
    selecionarTudo: Function,
    valorGlosadoTotal: Number,
    estadoList: Array,
    dadosPagamento: Object,
    desfazerEdicaoRecurso: Function,
    abreFormDados: Function,
    dadosExtras: Object,
    filterData: Object,
    motivosGlosaList: Array,
    parametros: Object,
    getGuiasAnalisadas: Function
  }
}
</script>

<style lang="scss">
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #eeeeee !important;
}
#table-guias {
  .validate-field {
    label.v-label.theme--light {
      font-size: 12px;
      color: #8f2c11;
    }
    label.v-label.v-label--active.theme--light.error--text {
      font-size: 12px;
      color: #ffffff00 !important;
    }
  }
  .theme--light.v-data-table {
    .no-box-shadow, .no-box-shadow *{
      box-shadow: 0 0 0 0!important;
    }
    .v-icon.v-icon {
      font-size: 16px !important;
    }
    .v-data-table__wrapper > table {
      border-collapse: separate;
    }
    .v-data-table__wrapper > table > thead > tr th:last-child,
    .v-data-table__wrapper > table > tbody > tr td:last-child {
      position: sticky !important;
      right: 0;
      /* Displayed on top of other rows when scrolling */
      z-index: 3;
      min-width: 82px;
      max-width: 82px
    }
    .v-data-table__wrapper > table > thead > tr th:first-child,
    .v-data-table__wrapper > table > tbody > tr td:first-child {
      position: sticky !important;
      left: 0;
      z-index: 2;
      min-width: 42px;
      max-width: 42px
    }
    .v-data-table__wrapper > table > thead > tr th:nth-child(2),
    .v-data-table__wrapper > table > tbody > tr td:nth-child(2)   {
      position: sticky !important;
      left: 42px;
      /* Displayed on top of other rows when scrolling */
      z-index: 2;
      min-width: 32px;
      padding: 0 0;
    }
    // .v-data-table__wrapper > table > thead > tr th:nth-child(3),
    // .v-data-table__wrapper > table > tbody > tr td:nth-child(3)   {
    //   position: sticky !important;
    //   left: 84px;
    //   /* Displayed on top of other rows when scrolling */
    //   z-index: 2;
    // }
    .v-data-table__wrapper > table > thead > tr th:first-child,
    .v-data-table__wrapper > table > thead > tr th:nth-child(2),
    .v-data-table__wrapper > table > thead > tr th:nth-child(3),
    .v-data-table__wrapper > table > thead > tr th:last-child {
      background-color: #eff3f8;
      padding-left: 8px;
      padding-right: 8px;
      z-index: 2;
    }

    .v-data-table__wrapper > table > tbody > tr td:nth-child(2) {
      background-color: rgb(255, 255, 255);
    }

    .v-data-table__wrapper > table > tbody > tr td:first-child, 
    .v-data-table__wrapper > table > tbody > tr td:last-child {
      background-color: #FFFFFF;// rgba(255, 255, 255, 1);
      padding-left: 8px;
      padding-right: 8px;
      z-index: 0;
    }
    .v-data-table__wrapper > table > tbody> tr > td .theme--light.v-input input {
      font-size: 0.875rem
    }
    .v-data-table__wrapper > table > tbody > tr.active td:nth-child(3) {
      background: #f1f2dc !important;
    }
    .v-data-table__wrapper > table > tbody > tr.active td:nth-child(2) {
      background: #f5f5f5 !important;
    }
    .v-data-table__wrapper > table > tbody > tr.validate {
      background: #f5f5f5 !important;
    }
    .v-data-table__wrapper > table > tbody > tr.validate td:nth-child(2) {
      background: #f5f5f5 !important;
    }
    .v-data-table__wrapper > table > tbody > tr.validate td:nth-child(3) {
      background: #f5f5f5 !important;
    }
    .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
      background: #eeeeee !important;
    }
    .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) td:nth-child(2) {
      background: #eeeeee !important;
    }
    .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) td:nth-child(3) {
      background: #eeeeee !important;
    }
    .v-data-table__wrapper > table > tbody > tr.v-data-table__selected td:nth-child(2) {
      background: #f5f5f5 !important;
    }
    .v-data-table__wrapper > table > tbody > tr.v-data-table__selected td:nth-child(3) {
      background: #f5f5f5 !important;
    }
  }
  .guiasListTable {
    .v-data-table__wrapper > table > tbody > tr td:nth-child(3) {
      background-color: rgb(255 255 255) !important;
      min-width: 80px;
    }
    /*.v-data-table__wrapper > table > tbody > tr td:nth-child(4){
      background-color: rgb(255 255 255) !important;
    }*/
    .v-data-table__wrapper > table > tbody > tr td:nth-child(6){
      padding-left: 4px;
      padding-right: 4px;
      min-width: 100px;
    }
    .v-data-table__wrapper > table > tbody > tr td:nth-child(9), 
    .v-data-table__wrapper > table > tbody > tr td:nth-child(17),
    .v-data-table__wrapper > table > tbody > tr td:nth-child(18)
    {
      background-color: rgba(207, 212, 3, .10) !important;
    }
    .v-data-table__wrapper > table > tbody > tr td:nth-child(9) {
      min-width: 140px;
    }
    .v-data-table__wrapper > table > tbody > tr td:nth-child(18),
    .v-data-table__wrapper > table > tbody > tr td:nth-child(18){
      min-width: 180px;
    }
    .v-data-table__wrapper > table > tbody > tr.validate17 td:nth-child(17),
    .v-data-table__wrapper > table > tbody > tr.validate td:nth-child(18) {
      background: #8f2c113d  !important;
      border-color: #8f2c1161  !important;
      left: 60%;
      width: 300px;
      height: auto;
      transition: .2s ease-in-out;
    }
    .v-data-table__wrapper > table > tbody > tr.valid-obrigatorio td:nth-child(17),
    .v-data-table__wrapper > table > tbody > tr.valid-obrigatorio td:nth-child(18) {
      background: #8f2c113d  !important;
      border-color: #8f2c1161  !important;
    }
  }
  .itensListTable {
    .v-data-table__wrapper > table > tbody > tr td:nth-child(3) {
      background-color: rgb(255 255 255) !important;
      min-width: 80px;
    }
    /*.v-data-table__wrapper > table > tbody > tr td:nth-child(4),
    .v-data-table__wrapper > table > tbody > tr td:nth-child(16),
    .v-data-table__wrapper > table > tbody > tr td:nth-child(19){
      background-color: rgb(255 255 255) !important;
    }
    */
    .v-data-table__wrapper > table > tbody > tr td:nth-child(14),
    .v-data-table__wrapper > table > tbody > tr td:nth-child(20),
    .v-data-table__wrapper > table > tbody > tr td:nth-child(24),
    .v-data-table__wrapper > table > tbody > tr td:nth-child(25) {
      //background-color: rgb(250 251 229) !important;
      background-color: rgba(207, 212, 3, .10) !important;
    }

    .v-data-table__wrapper > table > tbody > tr td:nth-child(12){
      max-width: 210px;
    }
    .v-data-table__wrapper > table > tbody > tr td:nth-child(25){
      min-width: 180px;
    }
    .v-data-table__wrapper > table > tbody > tr.validate17 td:nth-child(24),
    .v-data-table__wrapper > table > tbody > tr.validate td:nth-child(25) {
      background: #8f2c113d  !important;
      border-color: #8f2c1161  !important;
      left: 60%;
      width: 300px;
      height: auto;
      transition: .2s ease-in-out;
    }

    .v-data-table__wrapper > table > tbody > tr.valid-obrigatorio td:nth-child(24),
    .v-data-table__wrapper > table > tbody > tr.valid-obrigatorio td:nth-child(25) {
      background: #8f2c113d  !important;
      border-color: #8f2c1161  !important;
    }
    .v-text-field__details{
      margin-top: -12px;
    }
  }
}

</style>